var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useContext, useEffect } from "react";
import { useParams } from "react-router-dom";
import FilteredOverviewPage from "../../components/FilteredOverviewPage";
import { CohortFilterSet } from "../../components/Filters/Filters";
import { useLookupField } from "../../components/LookupField/LookupField";
import { useClient } from "../../hooks/client";
import { useRestrictionSetup } from "../../hooks/restrictionSetup";
import { FilterContext, updateFilters } from "../../providers/FilterProvider";
import { useGetCohortReportLeaderCount, useGetLeaderScoreAggByAssessmentQuery, useGetLeaderScoresAssessmentAggBySkillGroupQuery, useGetProject, useGetSingleAvailableCohortReportsQuery, } from "../../store/api/core";
import styles from "./CohortCapabilitiesLeadersV2.module.scss";
import { DistributionBarSet } from "../../components/DistributionBarSet/DistributionBarSet";
import { Tab } from "../../common/cohortHelpers";
import CohortInsightsSkillsTable from "../../components/CohortInsightsSkillsTable";
import { cohortSet } from "../../common/cohortConfiguration";
import LeaderCount from "../../components/LeaderCount";
import { AvailableFilters, getEntity, getAggregateLabelForEntity, } from "../../common/filters";
import { MutateReportButtons } from "../../components/Cohort/cohort";
import { CohortLeaderTableWrapper } from "../../components/CohortInsights/Restrictions";
import { Breadcrumb } from "../../components/Breadcrumb/Breadcrumb";
import { useConfidentialReportView } from "../../hooks/confidentialReportView";
import { useColumnedTableReportData } from "../../common/cohortTableColumns";
export var CohortProjectV2 = function () {
    var reportId = useParams().reportId;
    var reportData = useGetSingleAvailableCohortReportsQuery({
        reportId: reportId || "",
    });
    var _a = reportData.data || {}, assessmentCategory = _a.assessmentCategory, heatmapDimensions = _a.heatmapDimensions;
    var _b = useParams(), skillGroup = _b.skillGroup, role = _b.role, project = _b.project;
    var cohortSetInformation = cohortSet[assessmentCategory || Tab.CBI][skillGroup || ""];
    return (_jsx(CohortCapabilitiesLeaders, { category: assessmentCategory, dataKey: skillGroup, role: role || "", project: project || "", heatmapDimensions: heatmapDimensions, backToButton: _jsx(BackFromCohortProjectV2, {}), donutTitle: (cohortSetInformation === null || cohortSetInformation === void 0 ? void 0 : cohortSetInformation.heatmapDrilldownDonutTitle) || "", tableName: (cohortSetInformation === null || cohortSetInformation === void 0 ? void 0 : cohortSetInformation.skillGroupDisplayName) || "" }));
};
var BackFromCohortProjectV2 = function () { return _jsx(Breadcrumb, {}); };
export var useLeaderTitle = function (_a) {
    var _b, _c, _d;
    var role = _a.role, project = _a.project, reportId = _a.reportId;
    var reportData = useGetSingleAvailableCohortReportsQuery({
        reportId: reportId || "",
    }, { shouldSkipCall: function () { return !reportId; } });
    var heatmapDimensions = (reportData.data || {}).heatmapDimensions;
    var dimensions = heatmapDimensions;
    var rowDimension = dimensions === null || dimensions === void 0 ? void 0 : dimensions.xAxis;
    var columnDimension = dimensions === null || dimensions === void 0 ? void 0 : dimensions.yAxis;
    var isDynamicDrilldown = Boolean(rowDimension && columnDimension);
    var rowValue = project;
    var columnValue = role;
    var rowAll = (rowValue === null || rowValue === void 0 ? void 0 : rowValue.toLowerCase()) == "all";
    var columnAll = (columnValue === null || columnValue === void 0 ? void 0 : columnValue.toLowerCase()) == "all";
    var projectIdToFetch = isDynamicDrilldown
        ? rowDimension === "project" && !rowAll
            ? rowValue
            : columnDimension === "project" && !columnAll
                ? columnValue
                : undefined
        : project;
    var shouldFetchProject = Boolean(projectIdToFetch && (projectIdToFetch === null || projectIdToFetch === void 0 ? void 0 : projectIdToFetch.toLowerCase()) !== "all");
    var projectResponse = useGetProject({ id: projectIdToFetch !== null && projectIdToFetch !== void 0 ? projectIdToFetch : "" }, {
        shouldSkipCall: function () { return !shouldFetchProject; },
    });
    var client = useClient();
    var lookups = useLookupField({ clientId: client.clientId || undefined });
    var getDisplayValue = function (dimensionKey, value, isAll) {
        var _a, _b, _c;
        if (isAll) {
            return getAggregateLabelForEntity(dimensionKey);
        }
        if (dimensionKey === "project") {
            return ((_c = (_b = (_a = projectResponse === null || projectResponse === void 0 ? void 0 : projectResponse.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.name) || value || "";
        }
        return (lookups === null || lookups === void 0 ? void 0 : lookups[value]) || value || "";
    };
    var title = "";
    if (isDynamicDrilldown && rowDimension && columnDimension) {
        var rowText = getDisplayValue(rowDimension, rowValue, rowAll);
        var colText = getDisplayValue(columnDimension, columnValue, columnAll);
        title = "".concat(rowText, " + ").concat(colText);
    }
    else {
        var roleText = columnAll ? "All Functions" : (lookups === null || lookups === void 0 ? void 0 : lookups[role]) || "";
        var projectText = rowAll
            ? "All Projects"
            : ((_d = (_c = (_b = projectResponse === null || projectResponse === void 0 ? void 0 : projectResponse.data) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.name) || "(Misnamed Project)";
        title =
            lookups.size !== 0 && ((projectResponse === null || projectResponse === void 0 ? void 0 : projectResponse.data) || !shouldFetchProject)
                ? "".concat(projectText, " + ").concat(roleText)
                : "";
    }
    return title;
};
var allSetable = function (settable, value, dimension) {
    var _a;
    var isAll = (value === null || value === void 0 ? void 0 : value.toLowerCase()) === "all";
    if (!settable || isAll) {
        return {};
    }
    return _a = {},
        _a[dimension] = [value],
        _a;
};
export var CohortCapabilitiesLeaders = function (_a) {
    var _b;
    var _c, _d, _e, _f, _g, _h, _j, _k, _l;
    var dataKey = _a.dataKey, backToButton = _a.backToButton, role = _a.role, project = _a.project, tableName = _a.tableName, donutTitle = _a.donutTitle, heatmapDimensions = _a.heatmapDimensions;
    var reportId = useParams().reportId;
    var reportData = useGetSingleAvailableCohortReportsQuery({
        reportId: reportId || "",
    }, { shouldSkipCall: function () { return !reportId; } });
    var _m = reportData.data || {}, assessmentCategory = _m.assessmentCategory, isConfidential = _m.isConfidential, reportHeatmapDimensions = _m.heatmapDimensions;
    var title = useLeaderTitle({ role: role, project: project, reportId: reportId });
    var dimensions = heatmapDimensions !== null && heatmapDimensions !== void 0 ? heatmapDimensions : reportHeatmapDimensions;
    var rowDimension = dimensions === null || dimensions === void 0 ? void 0 : dimensions.xAxis;
    var columnDimension = dimensions === null || dimensions === void 0 ? void 0 : dimensions.yAxis;
    var isDynamicDrilldown = Boolean(rowDimension && columnDimension);
    var rowValue = project;
    var columnValue = role;
    var rowAll = (rowValue === null || rowValue === void 0 ? void 0 : rowValue.toLowerCase()) == "all";
    var columnAll = (columnValue === null || columnValue === void 0 ? void 0 : columnValue.toLowerCase()) == "all";
    var allFilters = useContext(FilterContext).getFilters;
    var disableFilters = useConfidentialReportView(isConfidential).disableFilters;
    var setable = React.useMemo(function () {
        if (!(reportData === null || reportData === void 0 ? void 0 : reportData.data)) {
            return {};
        }
        if (!role || !project) {
            return undefined;
        }
        if (isDynamicDrilldown && rowDimension && columnDimension) {
            var filterObject_1 = {};
            filterObject_1[rowDimension] = rowAll ? [] : [rowValue];
            filterObject_1[columnDimension] = columnAll ? [] : [columnValue];
            return filterObject_1;
        }
        var roleAll = (role === null || role === void 0 ? void 0 : role.toLowerCase()) == "all";
        var projectAll = (project === null || project === void 0 ? void 0 : project.toLowerCase()) == "all";
        var filterObject = {
            project: projectAll ? [] : [project],
        };
        if (!roleAll) {
            if (role.startsWith("SF")) {
                filterObject[getEntity(AvailableFilters.BusinessSubFunctions)] = [role];
            }
            else if (role.startsWith("F")) {
                filterObject[getEntity(AvailableFilters.BusinessFunctions)] = [role];
            }
        }
        return filterObject;
    }, [
        role,
        project,
        isDynamicDrilldown,
        rowDimension,
        columnDimension,
        rowAll,
        columnAll,
        rowValue,
        columnValue,
    ]);
    var cohortInformation = (_c = cohortSet[assessmentCategory || Tab.CBI]) === null || _c === void 0 ? void 0 : _c[dataKey];
    var restrictionSetup = __assign(__assign(__assign({}, (((_d = reportData === null || reportData === void 0 ? void 0 : reportData.data) === null || _d === void 0 ? void 0 : _d.filters) || {})), allSetable(setable, columnValue, columnDimension)), allSetable(setable, rowValue, rowDimension));
    useRestrictionSetup(restrictionSetup);
    useEffect(function () { return function () {
        var _a;
        var _b, _c, _d, _e;
        var change = (_a = {},
            _a[heatmapDimensions === null || heatmapDimensions === void 0 ? void 0 : heatmapDimensions.xAxis] = (_c = (((_b = allFilters()) === null || _b === void 0 ? void 0 : _b[heatmapDimensions === null || heatmapDimensions === void 0 ? void 0 : heatmapDimensions.xAxis]) || [])) === null || _c === void 0 ? void 0 : _c.filter(function (filter) { return filter !== project; }),
            _a[heatmapDimensions === null || heatmapDimensions === void 0 ? void 0 : heatmapDimensions.yAxis] = (_e = (((_d = allFilters()) === null || _d === void 0 ? void 0 : _d[heatmapDimensions === null || heatmapDimensions === void 0 ? void 0 : heatmapDimensions.yAxis]) || [])) === null || _e === void 0 ? void 0 : _e.filter(function (filter) { return filter !== role; }),
            _a);
        setTimeout(function () {
            updateFilters(change);
        }, 0);
    }; }, []);
    var column1Attribute = (_f = (_e = reportData === null || reportData === void 0 ? void 0 : reportData.data) === null || _e === void 0 ? void 0 : _e.leaderTableOptions) === null || _f === void 0 ? void 0 : _f.column1Attribute;
    var column2Attribute = (_h = (_g = reportData === null || reportData === void 0 ? void 0 : reportData.data) === null || _g === void 0 ? void 0 : _g.leaderTableOptions) === null || _h === void 0 ? void 0 : _h.column2Attribute;
    var cohortHeatmapTableData = useColumnedTableReportData({
        useTableData: useGetLeaderScoresAssessmentAggBySkillGroupQuery,
        reportId: reportId || "",
        skillGroup: dataKey,
        category: assessmentCategory || Tab.CBI,
    });
    var leaderCountData = useGetCohortReportLeaderCount({
        category: assessmentCategory || Tab.CBI,
        filters: allFilters(),
    }).data;
    var categoryLabels = (_b = {},
        _b[Tab.CBI] = "Final Assessor Rating",
        _b[Tab.SavilleWave] = "Saville Wave",
        _b[Tab.SavilleSwiftAptitude] = "Saville Swift Aptitude",
        _b[Tab.HoganHPI] = "Hogan HPI",
        _b[Tab.HoganHDS] = "Hogan HDS",
        _b[Tab.HoganMVPI] = "Hogan MVPI",
        _b);
    var category = categoryLabels[assessmentCategory] || "";
    // Conditional return AFTER all hooks
    if (!cohortInformation) {
        return (_jsx("div", __assign({ "data-testid": "CohortCapabilitiesLeaders", className: styles.container }, { children: _jsx("h2", { children: "Unknown Category and/or Skill Group" }) })));
    }
    return (_jsxs(_Fragment, { children: [_jsx(FilteredOverviewPage, { availableFilters: CohortFilterSet, title: title, leftTrailer: _jsx("div", __assign({ style: { paddingTop: "2px" } }, { children: _jsx(LeaderCount, { leadersCount: ((_j = leaderCountData === null || leaderCountData === void 0 ? void 0 : leaderCountData.data) === null || _j === void 0 ? void 0 : _j.leadersCount) || 0, countText: "leader" }) })), rightTrailer: _jsx(MutateReportButtons, { reportId: reportId || "" }), disableFilters: disableFilters, secondaryHeadingTitle: category ? "".concat(category, ": ").concat(title) : title, backToButton: backToButton }), _jsxs("div", __assign({ "data-testid": "CohortCapabilitiesLeaders", className: styles.container }, { children: [_jsx(DistributionBarSet, { useChartData: useGetLeaderScoreAggByAssessmentQuery, reportId: reportId || "", skillGroup: dataKey, skillName: cohortInformation.distributionSkillName, category: assessmentCategory || Tab.CBI, barTitle: cohortInformation.barChartTitle("".concat(title, " ").concat(cohortInformation.skillGroupDisplayName)), donutTitle: donutTitle, barChartProps: __assign({}, (cohortInformation.barChartProps || {})) }), _jsx(CohortLeaderTableWrapper, { children: _jsx("div", __assign({ className: styles.heatmapTableContainer }, { children: _jsx(CohortInsightsSkillsTable, { data: cohortHeatmapTableData, filename: "cohort-heatmap-table.png", title: "".concat(tableName, " Scores by Leader"), getColumnDescriptions: ((_l = (_k = cohortSet[assessmentCategory || Tab.CBI]) === null || _k === void 0 ? void 0 : _k[dataKey]) === null || _l === void 0 ? void 0 : _l.heatmapDrilldownColumns) || (function () { return []; }), column1Attribute: column1Attribute, column2Attribute: column2Attribute }) })) })] }))] }));
};
